import React, { useEffect, useState } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsCompleted,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const CompletedStatus = ({ query = "", userPermission }) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Состояния для пагинации
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = async (page = 1, pageSize = 20) => {
    try {
      setIsLoading(true);
      // Для завершённых заказов используем state "COMPLETED"
      const res = await fetchStatuses(
        "COMPLETED",
        "",
        query,
        setOrders,
        setIsLoading,
        setTotalCount,
        pageSize,
        page
      );
      setCurrentPage(res.data.currentPage || page);
      setLimit(pageSize);
      setTotalCount(res.data.totalCount || 0);
    } catch (err) {
      console.error("Error fetching CompletedStatus:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData(1, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    loadData(page, pageSize);
  };

  return (
    <div>
      <Table
        style={{ minWidth: 1000 }}
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsCompleted}
        dataSource={getOrderStatusDataSource(orders)}
        pagination={false} // отключаем встроенную пагинацию
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default CompletedStatus;
